module.exports = __webpack_public_path__ + "img/exhibidora.55ca4049.jpeg";